import React, { useEffect, useState } from 'react'
import { Image, Button, Modal } from "react-bootstrap";
import {
  ModalButton,
  ModalTitle,
  ModalSmallText,
  AddressText,
  ModalImage,
} from './mailAddressConfirmationStyle'
import NonprofitImage from '../../../assests/images/addressimg.webp';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

interface MailAddressConfirmationProps {
  open: boolean;
  setOpen: (val: boolean) => void;
  handleConfirm: () => void;
  handleEdit: () => void;
}
const MailAddressConfirmationModal: React.FC<MailAddressConfirmationProps> = ({ open, setOpen, handleConfirm, handleEdit }: any) => {
  const nonprofitStats = useSelector((state: any) => state?.nonprofitStats?.data?.results)

  const location = useLocation();
  const [showModal, setShowModal] = useState(false);

  // if (nonprofitStats?.is_address_confirm) {
  //   return null;
  // }

  useEffect(() => {
    if (location.state?.open && !nonprofitStats?.is_address_confirm) {
      setShowModal(true);
    }
  }, [location.state, nonprofitStats]);

  return (
    <Modal show={showModal} className='claim-nonprofit-modal'
      onHide={() => setShowModal(false)} centered>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <ModalImage><Image src={NonprofitImage} /></ModalImage>
        <ModalTitle>Mailing Address Confirmation</ModalTitle>
        <ModalSmallText>Hello {nonprofitStats?.title}</ModalSmallText>
        <ModalSmallText>
          <AddressText>Here is the address we have on file: </AddressText>
          <AddressText>{nonprofitStats?.address_1}</AddressText>
          <AddressText>{nonprofitStats?.address_2}</AddressText>
        </ModalSmallText>
        <ModalButton>
          <Button className='fill-btn modal-btn' onClick={handleConfirm}> Confirm Address</Button>
          <Button className='blank-btn modal-btn' onClick={handleEdit}>Edit Address</Button>
        </ModalButton>
      </Modal.Body>
    </Modal>
  )
}

export default MailAddressConfirmationModal;
